// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__SDpfN","contentContainer":"App_contentContainer__zg3Di"};